

.subtitle {
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

#vulnerable-drivers-section {
  display: flex;
  margin-top: 30px;

  #vulnerable-drivers-checkbox-form {
    width: 265px;
  }

  #vulnerable-drivers-radio-group-form {
    width: 375px;
  }

  gz-radio:not(:first-child) {
    margin-top: 22px;
  }
}

#callback-evasion-section {
  display: flex;
  margin-top: 30px;

  #callback-evasion-checkbox-form {
    width: 265px;
  }

  #callback-evasion-actions-section {
    width: 375px;

    #callback-evasion-actions-radio-group {
      display: flex;
      margin-top: 12px;

      gz-radio:not(:first-child) {
        margin-left: 20px;
      }

      gz-radio:first-child {
        margin-left: 25px;
      }
    }
  }
}
